import React, { Fragment, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import profile01 from "../../../../images/profile/1.jpg";
import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { NotificationManager } from "react-notifications";
import MUIDataTable from "mui-datatables";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import { Form, FormGroup, Label, Input } from "reactstrap";
import Select from "react-select";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";

import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge,
} from "reactstrap";
import { Row, Card, Col, Button, Container } from "react-bootstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";

/* import PageTitle from "../../../layouts/PageTitle"; */
//** Import Image */
/* import profile01 from "../../../../images/profile/1.jpg"; */
import profile02 from "../../../../images/profile/2.jpg";
import profile03 from "../../../../images/profile/3.jpg";
import profile04 from "../../../../images/profile/4.jpg";
import profile05 from "../../../../images/profile/5.jpg";
import profile06 from "../../../../images/profile/6.jpg";
import profile07 from "../../../../images/profile/7.jpg";
import profile08 from "../../../../images/profile/8.jpg";
import profile09 from "../../../../images/profile/9.jpg";
import profile from "../../../../images/profile/profile.png";
import img3 from "../../../../images/card/44.png";
import img6 from "../../../../images/card/img6.jpg";
import PageTitle from "../../../layouts/PageTitle";
import { setNestedObjectValues } from "formik";

import {
  saveoutletDetails,
  getRoleMaster,
  getoutletListMaster,
  gettstaffListMaster,
  resetPWDDetails,
  savestaffDetails,
  updatePWDstaffDetails,
  staffUpdateUserDetails, getUserByOutletREQ
} from "../../../../apiservicescall/api";


const OutletIndividualStafs = () => {
  const [activeToggle, setActiveToggle] = useState("posts");
  const [sendMessage, setSendMessage] = useState(false);
  const [postModal, setPostModal] = useState(false);
  const [cameraModal, setCameraModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [replayModal, setReplayModal] = useState(false);
  const [popUpPageShow, setPopUpPageShow] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [editPageShow, setEditPageShow] = useState();
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [addFieldValue, setAddFieldValue] = useState();
  const [errors, setErrors] = useState();
  const [PopupCommonStateTransfer, setPopupCommonStateTransfer] = useState();
  /* const [staffname,setStaffname]= useState(); */

  const [role, setRoll] = useState();

  const [restaurantDetails, setRestaurantDetails] = useState({
    // RestaurantDetails
    restName: "",
    restMobileNumber: "",
    restEmailId: "",
    // restWebsiteUrl: "",
    reststateName: "",
    restcityName: "",
    restPincodeName: "",

    // Fssi
    restFssaiRegNumber: "",
    restFssaiFile: "",
    restFssaiRegisterstateName: "",

    // KycDetails
    restGstNumber: "",
    restPanNumber: "",
    restGstFile: "",
    restPanFile: "",
    restOutdoorPhoto: "",
    restIndoorPhoto: "",

    // BankDetails
    restBankAcNumber: "",
    restBankName: "",
    restIFSCNO: "",

    // OutletWorkingHours
    restTimeMonday: "",
    restTimeTuesday: "",
    restTimeWednesday: "",
    restTimeThursday: "",
    restTimeFriday: "",
    restTimeSaturday: "",
    restTimeSunday: "",

    stateMaster: [
      { label: "TN", value: "TN" },
      { label: "Kerala", value: "Kerala" },
      { label: "Puduchery", value: "Puduchery" },
      { label: "Karnataka", value: "Karnataka" },
    ],

    cityMaster: [
      { label: "Chennai", value: "Chennai" },
      { label: "Coimbatore", value: "Coimbatore" },
      { label: "Trichy", value: "Trichy" },
      { label: "Madurai", value: "Madurai" },
    ],

    areaMaster: [
      { label: "600192", value: "600192" },
      { label: "600142", value: "600192" },
      { label: "600194", value: "600192" },
      { label: "600195", value: "600192" },
    ],

    businessMaster: [
      { label: "HOTEL CUM RESTAURANT", value: "HOTEL CUM RESTAURANT" },
      {
        label: "RESTAURANT / ONLINE FOOD SELLING",
        value: "RESTAURANT / ONLINE FOOD SELLING",
      },
      {
        label: "HOME BASED CANTEEN",
        value: "HOME BASED CANTEEN OR TIFFIN SERVICE",
      },
      { label: "TIFFIN SERVICE Center", value: "TIFFIN SERVICE Center" },
      { label: "Uduppi", value: "Uduppi" },
      { label: "Takeaway", value: "Takeaway" },
      { label: "WHOLESALER OF FOOD ITEM", value: "WHOLESALER OF FOOD ITEM" },
      {
        label: "RETAILER OF SNACKS / TEA SHOPS",
        value: "RETAILER OF SNACKS / TEA SHOPS",
      },
      { label: "DHABA", value: "DHABA" },
      {
        label: "HAWKER (FOOD TRUCK OR HAWKER)",
        value: "HAWKER (FOOD TRUCK OR HAWKER)",
      },
    ],

    bankMaster: [
      { label: "Bank of Baroda", value: "Bank of Baroda" },
      { label: "Bank of India", value: "Bank of India" },
      { label: "Canara Bank", value: "Canara Bank" },
      { label: "Indian Bank", value: "Indian Bank" },
      { label: "Indian Overseas Bank", value: "Indian Overseas Bank" },
      { label: "Union Bank of India", value: "Union Bank of India" },
      { label: "State Bank of India", value: "State Bank of India" },
      { label: "Axis Bank", value: "Axis Bank" },
      { label: "City Union Bank", value: "City Union Bank" },
      { label: "HDFC Bank", value: "HDFC Bank" },
      { label: "ICICI Bank", value: "ICICIBank" },
      { label: "Other Bank", value: "OtherBank" },
    ],

    /* staffRole: [
      { label: "Manager", value: "Manager" },
      { label: "Staff", value: "Staff" },
      { label: "Others", value: "Others" },
    ], */
  });

  const [responseofcuslist, setresponseofcuslist] = useState({
    totalItems: 1312,
    totalPages: 132,
    customers: [
      {
        id: "77CF2CD4-B9F0-44AF-8ACB-06B8B890640F",
        name: "samyuktha",
        mobileNo: "5284713651",
        uid: null,
        tsmPosNo: "JTSM005",
        zsmPosNo: "JZSM002",
        rsmPosNo: null,
        rsmName: null,
        zsmName: null,
        tsmName: "Gedela Naveen Kumar",
        jpretailer: "N",
        jprshopData: "N",
        jprshopDispUnit: "N",
        summary: "N",
        scheme: "J",
        regionCode: "17",
        regionName: "South",
        schemeDesc: "Johnson Pedder (Umang)",
        cusType: "2",
      },
      {
        id: "801A0F6A-6B83-4953-ADAC-099BBFE7EAFD",
        name: "Gayatri Enterprises",
        mobileNo: "8663299644",
        uid: null,
        tsmPosNo: null,
        zsmPosNo: null,
        rsmPosNo: null,
        rsmName: null,
        zsmName: null,
        tsmName: null,
        jpretailer: "N",
        jprshopData: "N",
        jprshopDispUnit: "N",
        summary: "N",
        scheme: "J",
        regionCode: "17",
        regionName: "South",
        schemeDesc: "Johnson Pedder (Umang)",
        cusType: "2",
      },
    ],
    currentPage: 0,
  });

  const [responseofcuslist2, setResponseofcuslist2] = useState([
    {
      staffid: "1",
      staffimg:
        "https://dev.loyaltyprogramrbppl.in/static/media/profile.a0c806c2.jpg",
      staffname: "Textuser1",
      role: "Manager",
      mobileno: "9632145789",
      emailid: "Textuser1@gmail.com",
      statustype: "Active",
    },
    {
      staffid: "9",
      staffimg:
        "https://dev.loyaltyprogramrbppl.in/static/media/profile.a0c806c2.jpg",
      staffname: "Textuser2",
      role: "Manager",
      mobileno: "9521456321",
      emailid: "Textuser2@gmail.com",
      statustype: "Inactive",
    },
    {
      staffid: "8",
      staffimg:
        "https://dev.loyaltyprogramrbppl.in/static/media/profile.a0c806c2.jpg",
      staffname: "Textuser3",
      role: "Staff",
      mobileno: "9520314256",
      emailid: "Textuser3@gmail.com",
      statustype: "Active",
    },

    {
      staffid: "15",
      staffimg:
        "https://dev.loyaltyprogramrbppl.in/static/media/profile.a0c806c2.jpg",
      staffname: "Textuser4",
      role: "Manager",
      mobileno: "9852146378",
      emailid: "Textuser4@gmail.com",
      statustype: "Active",
    },
    {
      staffid: "20",
      staffimg:
        "https://dev.loyaltyprogramrbppl.in/static/media/profile.a0c806c2.jpg",
      staffname: "Textuser5",
      role: "Staff",
      mobileno: "9852146378",
      emailid: "Textuser5@gmail.com",
      statustype: "Inactive",
    },
    {
      staffid: "12",
      staffimg:
        "https://dev.loyaltyprogramrbppl.in/static/media/profile.a0c806c2.jpg",
      staffname: "Textuser6",
      role: "Manager",
      mobileno: "9562314578",
      emailid: "Textuser6@gmail.com",
      statustype: "Active",
    },
  ]);

  const [staffrole, setStaffrole] = useState([
    { label: "Manager", value: "Manager" },
    { label: "Staff", value: "Staff" },
    { label: "Others", value: "Others" },
  ]);

  const [outlet, setOutlet] = useState([
    { label: "Ekkattuthangal", value: "Ekkattuthangal" },
    { label: "T nagar", value: "T nagar" },
    { label: "Mambalam", value: "Mambalam" },
  ]);

  const [staffdetails, setStaffdetails] = useState({
    staffid: "",
    staffimg: "",
    staffname: "",
    role: "",
    mobileno: "",
    emailid: "",
    statustype: "",
  });

  //stepper:
  const [activeStep, setActiveStep] = useState(0);
  const [popupModal, setPopupModal] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [contentModal, setContentModal] = useState(false);
  const [modalCentered, setModalCentered] = useState(false);
  const [modalWithTooltip, setModalWithTooltip] = useState(false);
  const [gridInsideModal, setGridInsideModal] = useState(false);
  const [largeModal, setLargeModal] = useState(false);
  const [smallModal, setSmallModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());
  const [staffMasterList, setStaffMasterList] = useState([]);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  useEffect(() => {
    // console.log("activeIndex", activeIndex)
    getstaffMasterList();
  }, [popUpPageShow]);

  const getstaffMasterList = async () => {

    let outletCode = userDetails?.outletResponses[0]?.outletCode;
    let companyCode = userDetails?.companyCode;

    let getoutletList = await getUserByOutletREQ(companyCode, outletCode);
    let getstaffListValue = getoutletList?.data?.data;
    console.log("getstaffListValue", getstaffListValue);
    setStaffMasterList(getstaffListValue);
  };


  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };

  const opnAddNewUserModal = (e) => {
    e.preventDefault();
    setLargeModal(!largeModal);
    setIsview(false);

    setIsedit(false);

    setStaffdetails({
      staffid: "",
      staffimg: "",
      staffname: "",
      mobileno: "",
      emailid: "",
      role: "",
    });
  };

  const opnpopUpPageShow = () => {
    setPopUpPageShow(!popUpPageShow);
  };

  const handleChangetabl = (event, value) => {
    setActiveIndex(value);
  };

  const onAddUpdateUserModalClose = () => {
    setPopUpPageShow(!popUpPageShow);
  };

  const onEditUser = (data) => {
    let selectedUser = responseofcuslist2.find(
      (value, index) => index === data?.rowIndex
    );

    setStaffdetails({
      staffid: selectedUser.staffid,
      staffimg: selectedUser.staffid,
      staffname: selectedUser.staffname,
      mobileno: selectedUser.mobileno,
      emailid: selectedUser.emailid,
      role: selectedUser.role,
    });
    console.log("staffdetails", staffdetails);
    setLargeModal(true);
    setIsview(true);
    setIsedit(false);
  };

  const viewUser = (data) => {
    let selectedUser = responseofcuslist2.find(
      (value, index) => index === data?.rowIndex
    );
    setStaffdetails({
      staffid: selectedUser.staffid,
      staffimg: selectedUser.staffid,
      staffname: selectedUser.staffname,
      mobileno: selectedUser.mobileno,
      emailid: selectedUser.emailid,
      role: selectedUser.role,
    });
    console.log("staffdetails", staffdetails);
    setResponseofcuslist2(responseofcuslist2);
    setLargeModal(true);
    /* setIsview(true); */
    setIsedit(true);
  };

  const onEditModalClose = () => {
    setEditPageShow(false);
  };

  /* const handleChange = (value, key) => {
    addFieldValue = {};

    if (key == "role") {
      
      setRoll();
    }
  }; */

  let actionOption = {
    name: "actions",
    label: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (summary, tableMeta, updateValue) => {
        // console.log("rowData[11] ", tableMeta.rowData[11])
        return (
          <div className="list-action">
            <span style={{ color: "black" }} className="icon-top-left">
              <button
                type="button"
                className="rct-link-btn edit-btn"
                onClick={() => onEditUser(tableMeta)}
              >
                <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
              </button>
            </span>
            <span style={{ color: "black" }} className="icon-top-right">
              <button
                type="button"
                className="rct-link-btn edit-btn"
                onClick={() => viewUser(tableMeta)}
              >
                <i style={{ fontSize: "15px" }} className="ti-eye"></i>
              </button>
            </span>
          </div>
        );
      },
    },
  };

  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  const columns = [
    {
      name: "staffid",
      label: "ID",
      options: {
        filter: false,
        sort: true,
        // customFilterListOptions: { render: v => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "staffimg",
      label: "Image",
      options: {
        filter: true,
        // customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",

        customBodyRender: (giftimageurl) => {
          let parentStyle = {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            boxSizing: "border-box",
            display: "block",
            width: "100%",
          };
          let cellStyle = {
            boxSizing: "border-box",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          };
          return (
            <div style={{ position: "relative", height: "35px" }}>
              <div style={parentStyle}>
                <div style={cellStyle}>
                  {/* <a href={giftimageurl} target="blank" > */}
                  <img
                    alt="Qries"
                    src={giftimageurl}
                    onClick={() => {
                      setPopUpPageShow(!popUpPageShow);
                      setTempModalPopupValue(giftimageurl);
                    }}
                    width="50%"
                    height="50%"
                    target="blank"
                  />
                </div>
              </div>
            </div>
          );
        },
      },
    },

    {
      name: "staffname",
      label: "Name",
      options: {
        filter: false,
        sort: true,
        // customFilterListOptions: { render: v => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "role",
      label: "Role",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "mobileno",
      label: "Mobile Number",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "emailid",
      label: "Email ID",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "statustype",
      label: "Active Status",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
        customBodyRender: (statustype, tableMeta) => {
          return (
            <>
              <div style={{ display: "flex" }}>
                {statustype == "Active" ? (
                  <span className="badge badge-rounded badge-danger">
                    Active
                  </span>
                ) : (
                  <span className="badge badge-rounded badge-success">
                    Inactive
                  </span>
                )}
                {/* <span className="d-block">
									{outletstatus == "Closed" ? "Closed" : "Open"}
								</span> */}
              </div>
            </>
          );
        },
      },
    },

    actionOption,
  ];

  const options = {
    filter: false,
    setFilterChipProps: (colIndex, colName, data) => {
      return {
        color: "primary",
        variant: "outlined",
        className: "testClass123",
      };
    },

    filterType: "dropdown",
    selectableRows: false,
    responsive: "stacked",
    // count: totalItems,
    search: false,
    // textLabels: {
    // 	body: {
    // 		noMatch: labelmessage
    // 	},
    // },

    fixedHeader: true,
    tableBodyHeight: "425px",

    fixedSelectColumn: true,
    // page: currentPage,
    pagination: true,
    serverSide: true,
    // rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    // onColumnSortChange: this.customSort,
    onChangePage: (page) => this.changePage(page),
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterVal,
      filterOptions,
      changedColumnIndex,
      displayData
    ) => {
      if (type === "chip") {
        var newFilters = () => filterList;
        this.handleFilterSubmit(newFilters);
      }
    },

    onSearchChange: (searchValue) => this.customSearch(searchValue),
    // table's internal filterList
    confirmFilters: true,

    // Calling the applyNewFilters parameter applies the selected filters to the table
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => this.handleFilterSubmit(applyNewFilters)}
          >
            Apply Filters
          </Button>
        </div>
      );
    },

    // callback that gets executed when filters are confirmed
    onFilterConfirm: (filterList) => {
      //// console.log('onFilterConfirm');
      // console.log('filterList', filterList);
    },

    onFilterDialogOpen: () => {
      //// console.log('filter dialog opened');
    },
    onFilterDialogClose: () => {
      //// console.log('filter dialog closed');
    },
    customToolbar: () => {
      return (
        <>
          <>
            <a
              href="#"
              style={{ backgroundColor: "#4cb32b", color: "white" }}
              onClick={(e) => opnAddNewUserModal(e)}
              className="caret btn-sm mr-10"
            >
              Add Staff <i className="zmdi zmdi-lus"></i>
            </a>
          </>
        </>
      );
    },
    // onChangeRowsPerPage: onChangeRowsPerPage,
    // sortOrder: {
    // 	name: sort,
    // 	direction: sortByAscending ? "asc" : "desc",
    // },

    //Search Query for list

    // customSearchRender: (searchText, handleSearch, hideSearch, options) => {
    //   // console.log(searchText);
    //   return (
    // 	<>
    // 	  <CustomSearchRender
    // 		debounceWait={500}
    // 		searchText={searchText}
    // 		onSearch={this.handleSearch}
    // 		onHide={hideSearch}
    // 		options={options}
    // 		onClear={this.handleClear}
    // 		searchField={this.state.searchField}
    // 		searchValue={this.state.searchValue}
    // 		fields={this.state.fields}
    // 		handleFieldChange={this.handleFieldChange}
    // 	  />
    // 	</>
    //   );
    // },
  };

  return (
    <>

      {/* <h3 className="mb-3 me-auto" style={{ fontFamily: "Roboto" }}>      
      </h3> */}

      <h3 className="me-auto" style={{ fontFamily: "Roboto", color: "darkgreen" }}>
        Outlet Staff List
      </h3>

      <div className="row dash-cards">
        {staffMasterList && staffMasterList.map((items) => {
          return <Col xl="4">
            <Card
              className=""
            >
              <Card.Header>
                <Card.Title style={{ fontFamily: "Poppins" }}>
                  {items?.userName}
                </Card.Title>
              </Card.Header>

              <Card.Body className="text-center">
                <img src={items?.userImagePath || img6} className="prf-img"
                  width="100px" height="100px" alt="Card cap" />
                <Card.Text>
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      {items?.email}<br />
                      {items?.mobileNo}
                    </div>
                  </div>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        })}
      </div>

      {(staffMasterList && staffMasterList.length <= 0) &&
        <h3 className="mb-3 me-auto" style={{
          fontFamily: "Roboto",
          marginLeft: "532px",
          color: "red"
        }}>
          List Not Found
        </h3>
      }


    </>
  );
};

export default OutletIndividualStafs;


{/* <Col xl="4">

<Card
  className=""
  onClick={() => {

  }}
>
  <Card.Header>
    <Card.Title style={{ fontFamily: "Poppins" }}>
      {" "}
      TestUser2{" "}
    </Card.Title>
  </Card.Header>

  <Card.Body className="text-center">
    <img src={img6} className="prf-img" width="100px" height="100px" alt="Card cap" />
    <Card.Text>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          {" "}

          <h4>Staff</h4>
          <h4>2356</h4>
          <h4>9235689541</h4>
          <h4>Chennai</h4>

        </div>
      </div>
    </Card.Text>
  </Card.Body>
</Card>

</Col>

<Col xl="4">

<Card
  className=""
  onClick={() => {

  }}
>
  <Card.Header>
    <Card.Title style={{ fontFamily: "Poppins" }}>
      {" "}
      TestUser3{" "}
    </Card.Title>
  </Card.Header>

  <Card.Body className="text-center">
    <img src={img6} className="prf-img" width="100px" height="100px" alt="Card cap" />
    <Card.Text>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12">
          {" "}

          <h4>Staff</h4>
          <h4>5629</h4>
          <h4>9632145689</h4>
          <h4>Chennai</h4>

        </div>
      </div>
    </Card.Text>
  </Card.Body>
</Card>

</Col> */}
